export const COLOR = {
    DARY_GREY: "#000000bd",
    MEDIUM_GREY: "#00000094",
    LIGHT_GREY: "#808080ad",
    LIGHT_WHITE: '#ffffffab',
    MEDIUM_LIGHT:'#ffffff4f',
    BLUE: "#1a75ff"
  };

  export const SHADOW = {
    DARK_SHADOW: '0px 0px 4px black',
    LIGHT_SHADOW: '0px 0px 4px white',
    MEDIUM_DARK_SHADOW: '0px 0px 4px #e1e1e1a6',
  }
